(function($) {
  new Swiper('.block-hotelcarousel .swiper-container', {
    grabCursor: true,
    slidesPerView: 1.25,
    spaceBetween: 20,
    autoHeight: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      576: {
        slidesPerView: 2.25,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.25,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 2.75,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 4.25,
        spaceBetween: 30,
      },
      1700: {
        slidesPerView: 4.25,
        spaceBetween: 40,
      },
    }
  });
})(jQuery);